import { Control, FieldValues, Path } from 'react-hook-form';
import { AutocompleteControl } from '../form/AutoCompleteControl';

const TITLE_OPTIONS = ['Dr.', 'Prof.', 'Prof. Dr.', 'Dipl. -Ing.'];
// Require at least one unicode letter
const PATTERN = /\p{L}+/u;

type TitleAutocompleteProps<T extends FieldValues> = {
  name: Path<T>;
  id?: string;
  control: Control<T>;
  disabled?: boolean;
};

export function TitleAutocompleteControl<T extends FieldValues>(props: TitleAutocompleteProps<T>) {
  const { control, name, id, disabled } = props;

  return (
    <AutocompleteControl
      name={name}
      control={control}
      options={TITLE_OPTIONS}
      id={id}
      disabled={disabled}
      rules={{ pattern: PATTERN }}
      freeSolo
    />
  );
}
